<ion-app>
  <ion-router-outlet></ion-router-outlet>

  @if (showPamFab) {
    <ion-fab slot="fixed" vertical="bottom" horizontal="start">
      <ion-fab-button (click)="goToPam()">
        <ion-icon name="arrow-undo-outline"></ion-icon>
      </ion-fab-button>
    </ion-fab>
  }

  <app-tutorial-overlay />
</ion-app>
